<template>

    <div class="d-none d-xl-block d-lg-block col-5 pt-5">
      <header class="pt-3 pb-4 pl-4">
        <figure >
          <img class="bitmap" :src="logo" :alt="logoAltText">
        </figure>
      </header>

      <div class="row py-3 pl-4" v-for="(content,index) in textContent" :key="index">
        <div class="col-12 ">
          <div class="d-inline-block align-middle oval col-3">
            <img :src="content.image" :title="content.imageTitle" :alt="content.imageAltText">
          </div>
          <div class="d-inline-block align-middle pl-3 col-9">
            <div class="title">{{content.title}}</div>
            <div class="text">{{content.description}}</div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>

  export default {

    data () {
      return {
        logo: 'https://images.livspace-cdn.com/w:156/h:34/dpr:2/plain/https://d3gq2merok8n5r.cloudfront.net/bumblebee/common/livspace-new-logo-1651660705-3hLxV.png',
        logoAltText : 'Livspace Logo',
        textContent:[
          {
            image : 'https://images.livspace-cdn.com/plain/https://d3gq2merok8n5r.cloudfront.net/accounts-ui/wishlist.svg',
            imageTitle : 'create wishlist',
            imageAltText : 'create wishlist',
            title: 'Create a wishlist',
            description: 'Beautiful home interiors to seek inspiration from'
          },
          {
            image : 'https://images.livspace-cdn.com/plain/https://d3gq2merok8n5r.cloudfront.net/accounts-ui/catalog.svg',
            imageTitle : 'Browse Catalogue',
            imageAltText : 'Browse Catalogue',
            title: 'Browse catalogue',
            description: 'Widest range of furniture, decor and modular products'
          },
          {
            image : 'https://images.livspace-cdn.com/plain/https://d3gq2merok8n5r.cloudfront.net/accounts-ui/quote_v2.svg',
            imageTitle : 'Get Free Quote',
            imageAltText : 'Get Free Quote',
            title: 'Get free quote',
            description: 'Review quotes for your home interiors'
          }
        ]
      }
    },
  }

</script>


<style scoped>
.title{
color: #000000;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    font-style: normal;
}
.text {
    font-family: 'Roboto', sans-serif;
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
color: #000000;
margin-top: 8px;
}
</style>
